import { connect } from 'react-redux';

import Component from './CampusGroups.component';
import { getCampusGroups, SAVE_CAMPUS_GROUP, DELETE_CAMPUS_GROUP } from '../+store/CampusGroups';
import { asyncFinish } from '../../common/+store/async';

const mapStateToProps = (state) => ({
  profile: state.modules.Auth.auth.profile,
  groups: state.modules.Settings.campusGroups.groups,
  schoolList: state.modules.Settings.schoolSettings.schoolList,
  // Scenario runs reuse the A-F page's year + assessment selection.
  filters: state.modules.AtoF.aToF.filters,
  assessmentList: state.modules.Assessments.assessments.assessmentList,
  assessmentGroups: state.modules.Assessments.groupAssessments.assessmentGroups,
});

const mapDispatchToProps = (dispatch) => ({
  getCampusGroups: () => {
    dispatch(getCampusGroups());
  },
  // The component calls the callables directly (inline error surfacing); these
  // land the results in the store so the A-F picker stays in sync.
  groupSaved: (data) => {
    dispatch(asyncFinish(SAVE_CAMPUS_GROUP, data));
  },
  groupDeleted: (data) => {
    dispatch(asyncFinish(DELETE_CAMPUS_GROUP, data));
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
